import React from "react";
import AlcoholSVG from "../AlcoholSVG";
import { QuestionQuestionSelect } from "../type";

const QuestionSelectSelect: React.VFC<{
    questionSelects: QuestionQuestionSelect[];
    currentQuestionNo: number;
    dispatch: Function;
}> = (props) => {
    const handleAnswer = ({ question_select, answer, nextQuestionNo }) => {
        props.dispatch({
            type: "ANSWER",
            nextQuestionNo,
            questionNo: props.currentQuestionNo,
            answer,
            question_select,
        });
    };

    const dynamicClassName = () => {
        if (props.currentQuestionNo == 17) {
            return "w-1/2 QuestionSelectBorder Option-17 Option-NoHoverCheckbox";
        } else if (
            [1, 2, 3, 4, 5, 6, 7, 8, 9].includes(props.currentQuestionNo)
        ) {
            return "w-1/2 QuestionSelectBorder";
        } else if ([11, 21].includes(props.currentQuestionNo)) {
            return "QuestionSelectBorder Option-11";
        } else {
            return "QuestionSelectBorder";
        }
    };

    return (
        <>
            {props.currentQuestionNo == 9 && (
                <div className="mx-auto text-center mb-8 mt-10">
                    <AlcoholSVG />
                </div>
            )}
            <div className="QuestionSelect mt-10">
                {props.questionSelects.map((question_select, i) => {
                    return (
                        <div
                            className={dynamicClassName()}
                            key={i * props.currentQuestionNo}
                            onClick={() => {
                                handleAnswer({
                                    question_select,
                                    answer: question_select.text,
                                    nextQuestionNo:
                                        question_select.next_question_no,
                                });
                            }}
                        >
                            {!!question_select.question_selects_image && (
                                <img
                                    className="mx-auto w-full"
                                    src={question_select.question_selects_image}
                                />
                            )}
                            <div className="QuestionSelectBorder-Text px-6 text-sm whitespace-pre text-center">
                                {question_select.text}
                            </div>
                        </div>
                    );
                })}
                {props.currentQuestionNo == 17 && (
                    <div className={`${dynamicClassName()} Option-NoHover`} />
                )}
            </div>
        </>
    );
};

export default QuestionSelectSelect;
